import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styled, { keyframes } from 'styled-components';

interface Props {
  message: string;
  position: number;
  duration?: number;
  onClose: () => void;
}

function Toast({ message, duration = 3000, position, onClose }: Props) {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return ReactDOM.createPortal(
    <ToastContainer $position={position} role="status" aria-live="polite">
      <CheckIcon />
      {message}
    </ToastContainer>,
    document.body,
  );
}

export default Toast;

const slideIn = keyframes`
  from { transform: translate(-50%, 8px); opacity: 0; }
  to   { transform: translate(-50%, 0);   opacity: 1; }
`;

const ToastContainer = styled.div<{ $position: number }>`
  position: fixed;
  bottom: ${({ $position }) => `${$position}px`};
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;

  display: inline-flex;
  padding: 12px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.77);
  box-shadow: 0 4px 15px 0 rgba(141, 149, 163, 0.25);
  animation: ${slideIn} 300ms ease-out;
  pointer-events: none;

  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const CheckIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#008AFF" />
      <g clip-path="url(#clip0_4890_43237)">
        <path
          d="M14.8619 6.19526C15.1223 5.93491 15.5443 5.93491 15.8046 6.19526C16.065 6.45561 16.065 6.87762 15.8046 7.13797L8.47135 14.4713C8.21101 14.7316 7.7889 14.7316 7.52855 14.4713L4.19526 11.138C3.93491 10.8776 3.93491 10.4556 4.19526 10.1953C4.43934 9.95118 4.82534 9.93612 5.08719 10.1497L5.13797 10.1953L7.99995 13.0572L14.8619 6.19526Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4890_43237">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
